export const CHECKIN_LIST_INITING             = 'CHECKIN_LIST_INITING'
export const CHECKIN_LIST_REQUESTING          = 'CHECKIN_LIST_REQUESTING'
export const CHECKIN_LIST_SUCCESS             = 'CHECKIN_LIST_SUCCESS'
export const CHECKIN_LIST_ERROR               = 'CHECKIN_LIST_ERROR'   

export const CHECKIN_UPDATE_REQUESTING        = 'CHECKIN_UPDATE_REQUESTING'
export const CHECKIN_UPDATE_SUCCESS           = 'CHECKIN_UPDATE_SUCCESS'
export const CHECKIN_UPDATE_ERROR             = 'CHECKIN_UPDATE_ERROR'   

export const CHECKIN_REPORT_REQUESTING          = 'CHECKIN_REPORT_REQUESTING'
export const CHECKIN_REPORT_SUCCESS             = 'CHECKIN_REPORT_SUCCESS'
export const CHECKIN_REPORT_ERROR               = 'CHECKIN_REPORT_ERROR' 

export const CHECKIN_REPORT_NVKD_REQUESTING      = 'CHECKIN_REPORT_NVKD_REQUESTING'
export const CHECKIN_REPORT_NVKD_SUCCESS         = 'CHECKIN_REPORT_NVKD_SUCCESS'
export const CHECKIN_REPORT_NVKD_ERROR           = 'CHECKIN_REPORT_NVKD_ERROR'

export const CHECKIN_REPORT_EXPORT_XLS_REQUESTING   = 'CHECKIN_REPORT_EXPORT_XLS_REQUESTING'
export const CHECKIN_REPORT_EXPORT_XLS_SUCCESS      = 'CHECKIN_REPORT_EXPORT_XLS_SUCCESS'
export const CHECKIN_REPORT_EXPORT_XLS_ERROR        = 'CHECKIN_REPORT_EXPORT_XLS_ERROR'

export const CHECKIN_KHACHHANG_REQUESTING        = "CHECKIN_KHACHHANG_REQUESTING"

export const CHECKIN_LIST_API                 = '/api/v1/users/get_list_checkin_by_user'   
export const CHECKIN_UPDATE_API               = '/api/v1/users/checkin_update_by_user'   
export const CHECKIN_REPORT_API               = '/api/v1/users/get_list_checkin_by_store'   
export const CHECKIN_REPORT_NVKD_API          = '/api/v1/users/get_list_by_quanly' 
export const CHECKIN_REPORT_EXPORT_XLS_API    = '/api/v1/users/export_list_checkin_by_store' 
export const CHECKIN_KHACHHANG_API            = '/api/v1/khachhang/KhachByNvkd' 


// WEBPACK FOOTER //
// ./src/views/Checkin/constants.js